import { createSelector } from 'reselect';
 
const selectCreditDebitNotes = (state: any) => state.creditDebitNotes;
 
export const selectCreditDebitNotesCurrentItem = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.current);
 
export const selectCreditDebitNotesListItems = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.list);
 
 
export const selectCreditDebitNotesItemById = (itemId: any) =>
    createSelector(selectCreditDebitNotesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectCreditDebitNotesQueryItems = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.query);

export const selectCreditDebitNotesCreatedItem = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.create);
 
export const selectCreditDebitNotesUpdatedItem = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.update);
 
export const selectCreditDebitNotesReadItem = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.read);
 
export const selectCreditDebitNotesDeletedItem = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.delete);
 
export const selectCreditDebitNotesSearchedItems = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.search);
 
export const selectCreditDebitNotesItemsCount = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.count);
 
export const selectCreditDebitNotesItemsFilter = createSelector([selectCreditDebitNotes], (creditDebitNotes) => creditDebitNotes.filter);